import * as React from "react";

interface IProps {
    navClass: string;
    isHideLogo?: boolean;
}

interface IState {
    menuOnMobileDisplay: string
}

export class Navigation extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            menuOnMobileDisplay: ''
        }
    }

    public render() {
        return (
            <nav className={this.props.navClass}>
                <div className="full-wrapper relative clearfix">
                    {!this.props.isHideLogo && (
                        <div className="nav-logo-wrap local-scroll">
                            <a href="/" className="logo">
                                <img src="asset/image/logo-xs.png" alt="" />
                            </a>
                        </div>
                    )}

                    <div className="mobile-nav">
                        <i
                            onClick={this.onMobileMenuClicked}
                            className="fa fa-bars" />
                    </div>
                    <div className={'inner-nav desktop-nav ' + this.state.menuOnMobileDisplay}>
                        <ul className="clearlist">
                            <li><a className="active" href="/">Beranda </a></li>
                            <li><a href="/berita">Berita</a></li>
                            <li><a href="/pengumuman">Pengumuman </a></li>
                            <li><a href="/agenda">Agenda </a></li>
                            <li><a href="/galeri">Galeri </a></li>
                            <li>
                                <a className="mn-has-sub" href="#">
                                    Informasi Desa 
                                    <i className="fa fa-angle-down" />
                                </a>
                                <ul className="mn-sub">
                                    <li><a href="/organisasi-desa">Organisasi Desa</a></li>
                                    <li><a href="/dusun">Dusun</a></li>
                                    <li><a href="/staff-desa">Staf</a></li>
                                </ul>
                            </li>
                            <li><a href="/aspirasi-pengaduan">Aspirasi & Pengaduan </a></li>
                            <li><a href="http://gis.sanurkauh.desa.id">GISAKA </a></li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }

    private onMobileMenuClicked = () => {
        this.setState({
            menuOnMobileDisplay: this.state.menuOnMobileDisplay === 'show-mobile-menu' ? '' : 'show-mobile-menu'
        })
    }
}


// WEBPACK FOOTER //
// ./src/component/layout/Navigation.tsx